import React, {Component} from "react"
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'

class SponsoredAdCard extends Component {
	constructor () {
		super()
		this.state = {}
	}
	render () {
		return (
			<div>
				<Container>
					<Row className=".justify-content-md-center">
						<Col xs lg="12">
					      <div className="sponsoredAdCard">
					      		<Row>
					      			<Col md="3" xs="4" lg="2">
					      				<div className="iconLabel">
					      					<span>A</span>
					      				</div>
					      			</Col>

					      			<Col md xs lg="6">
					      				<Row>
					      					<span className="owner">Ade Phones and accessories</span>
					      				</Row>
					      				<Row>
					      					<span className="title">Apple MacBook Pro, 2019</span>
					      				</Row>
					      				<Row>
					      					<span className="location">Lekki Phase 1, Lagos</span>
					      				</Row>
					      				<Row>
					      					<a href="/item-detail" className="link">See item</a>
					      				</Row>
					      			</Col>

					      			<Col md lg="4">
					      				<Row>
					      					<div className="sponsored right">SPONSORED</div>
					      				</Row>
					      				<Row>
					      					<div className="amount right">₦ 250,000</div>
					      				</Row>
					      				<Row>
					      					<div className="location right">&nbsp;</div>
					      				</Row>
					      				<Row>
					      					<div className="minsAgo right">5 mins ago</div>
					      				</Row>
					      			</Col>
					      		</Row>
					      </div>
					    </Col>
					  </Row>
				</Container>
			</div>
		)
	}
}

export default SponsoredAdCard